module.exports = __webpack_public_path__ + "img/deen.3da5e6fd.jpg";